export const data = {
  
    items: [
         { 
           id:1,
           title: "NYERGES SZERELVÉNYEK",
           desc: "Modern és megbízható nyerges szerelvényeink a hatékony és biztonságos áruszállítás alapjait képezik, míg kis-tehergépjárműveink rugalmas megoldásokat kínálnak a kisebb szállítmányok számára. Gépparkunk minőségi szolgáltatásunk alapját teremti meg, hogy ügyfeleink számára optimális logisztikai megoldásokat nyújthassunk",
           button:"Ismerje meg nyerges szerelvényinket",
           info:"25 db 40 tonnás normál / mega ponyvás kamion",
           paragraph:"Nyerges szerelvényeink korszerű és környezetbarát EURO 6 környezetvédelmi besorolású vontatókkal rendelkeznek, amelyek biztosítják a környezetvédelmi szabványoknak való megfelelést. A járműparkunk részeként elérhető MEGA kivitelű nyerges szerelvények kiemelkedően magas, 3 méteres belmagassággal rendelkeznek, lehetővé téve a hatékony és biztonságos rakodást. Minden pótkocsink XL-code tanusítvánnyal és rolóponyvával rendelkezik. A GPS nyomkövetés biztosítja a járműveink pontos követését és elérhetőségét minden pillanatban.",
           attributes:[
            {
                name:"Össztömeg",
                value:"40 tonna",
            },
            {
                name:"Besorolás",
                value:"Euro 6",
            },
            {
                name:"GPS nyomkövetés",
                value:"Igen",
            },
            {
                name:"Mennyiség",
                value:"25 db",
            }
           ],
           
           properties:[
            { value:"MEGA, kiemelhető tetős, 3 m belmagasságú ponyvás, daruzható pótkocsik" },
            { value:"XL Kódos ponyvás, daruzható pótkocsik" },
            { value:"EURO 6 környezetvédelmi besorolású vontatók" },
            { value:"GPS nyomkövetés" },
            { value:"Mennyiség: 25db" }
           ],
           icon:require("../../assets/img/icons/icon-02-primary.png"),
           main_pic: require("../../assets/img/trucks/big/01.jpg"),
           more_pics:[
            {
               pic:require("../../assets/img/trucks/big/02.jpg")
            },
            {
               pic:require("../../assets/img/trucks/big/03.jpg")
            },
            {
               pic:require("../../assets/img/trucks/big/04.jpg")
            },
            
           ]
        },
        { 
            id:2,
            title: "KIS-TEHERGÉPJÁRMŰVEK",
            desc: "Kis-tehergépjárműveink kiválóan alkalmasak a rugalmas és gyors áruszállításra, ideális megoldást nyújtva kisebb szállítmányok számára. Modern járműparkunk a hatékonyság és időbeni szállítás jegyében áll, hogy ügyfeleinknek optimális logisztikai megoldásokat biztosítsunk minden fuvarban",
            button:"Ismerje meg kis-tehergépjárműveinket",
            info:"8 db 12 tonnás ponyvás kamion",
            paragraph:"Kis-tehergépjárműveink a 7,5 és 12 tonna össztömegű tehergépkocsik kategóriájába tartoznak, optimális méretükkel és teherbírásukkal kiválóan alkalmasak változatos szállítási igények kielégítésére. A 7,2-8,5 méteres platóhosszúságú, ponyvás és daruzható felépítmények rugalmas választási lehetőségeket nyújtanak a szállítandó áruk jellegéhez és méretéhez igazítva. Az 2,8 - 5,8 tonnás terhelhetőségük ideális a kisebb és közepes méretű szállítmányok hatékony fuvarozásához. A beépített GPS nyomkövetés további előnyt biztosít, lehetővé téve a járművek pontos követését és optimalizált logisztikai megoldásokat.",
            attributes:[
                {
                    name:"Össztömeg",
                    value:"7,5 és 12 tonna",
                },
                {
                    name:"Platóhosszúság",
                    value:"7,2-8,5 m",
                },
                {
                    name:"Terhelhetőség",
                    value:"2,8 - 5,8 to",
                },
                {
                    name:"GPS Nyomkövetés",
                    value:"Igen",
                },
                {
                    name:"Mennyiség",
                    value:"8 db",
                }
               ],
               properties:[
                { value:"7,5 és 12 tonna össztömegű tehergépkocsik"},
                { value:"2,8 - 5,8 to terhelhetőség" },
                { value:"7,2-8,5 m platóhosszúságú, ponyvás, daruzható felépítmények"},
                { value:"GPS Nyomkövetés" },
                { value:"Mennyiség: 8db" }
               ],
            icon:require("../../assets/img/icons/icon-10.png"),
            main_pic: require("../../assets/img/trucks/little/01.jpg"),
            more_pics:[
               {
                  pic: require("../../assets/img/trucks/little/02.jpg"), 
               },
              
            ]
         },
         { 
            id:3,
            title: "FURGONOK",
            info:"6 db 3,5 tonnás ponyvás/ dobozos furgon",
            desc: "Járműveink között találhatók kiváló minőségű, 3,5 tonnás ponyvás és dobozos furgonjaink, melyek ideálisak sürgős szállításokhoz. A járműveink a legmodernebb GPS nyomonkövető rendszerrel vannak felszerelve, biztosítva ezzel a hatékony és pontos logisztikai megoldásokat ügyfeleinknek.",
            button:"Ismerje meg furgonjainkat",
            paragraph:"Furgonjaink a könnyű szállítás kiváló megoldását nyújtják, ideálisak a gyors és rugalmas kiszállításokhoz. A 3,5 tonnás ponyvás és dobozos furgonok rendkívül alkalmazkodóképesek, és ideálisak sürgős szállításokhoz. Kiemelkedően praktikusak a vállalatok számára, akik gyorsan és hatékonyan kívánják kiszolgálni ügyfeleiket. A beépített GPS nyomkövetés biztosítja a járművek valós idejű követését, lehetővé téve a pontos és időben történő szállításokat.",
            attributes:[
                {
                    name:"Össztömeg",
                    value:"3,5 to",
                },
                {
                    name:"Besorolás",
                    value:"Euro 6",
                },
                {
                    name:"GPS nyomkövetés",
                    value:"Igen",
                },
                {
                    name:"Mennyiség",
                    value:"6 db",
                }
               ],
            properties:[
                { value:"3,5 tonnás ponyvás/ dobozos furgon" },
                { value:"GPS Nyomkövetés" },
                { value:"Mennyiség: 6db" }
            ],
            icon:require("../../assets/img/icons/van.png"),
            main_pic: require("../../assets/img/trucks/van/01.jpg"),
            more_pics:[
             {
                pic:require("../../assets/img/trucks/van/02.jpg")
             },
             {
                pic:require("../../assets/img/trucks/van/03.jpg")
             },
            ]
         },
    ]  
       
 }
 
 